class MultiSelectTransfer {
    constructor(leftSelectId, rightSelectId, moveLeftButtonId, moveRightButtonId, hiddenInputId, sort=false) {
        this.leftSelect = document.querySelector(leftSelectId);
        this.rightSelect = document.querySelector(rightSelectId);
        this.moveLeftButton = document.querySelector(moveLeftButtonId);
        this.moveRightButton = document.querySelector(moveRightButtonId);
        this.hiddenInput = document.querySelector(hiddenInputId);
        this.sort = sort;

        this.setupEventListeners();
    }

    moveSelected(from, to) {
        const selectedOptions = Array.from(from.options).filter(option => option.selected);
        const fromGroup = from.querySelector('optgroup');
        const toGroup = to.querySelector('optgroup');
        selectedOptions.forEach(option => {
            toGroup.appendChild(new Option(option.text, option.value));
            fromGroup.removeChild(option);
        });

        if (this.sort) {
            this.sortSelect(fromGroup);
            this.sortSelect(toGroup);
        }

        this.updateHiddenInput();
    }

    setupEventListeners() {
        if (!this.leftSelect || !this.rightSelect || !this.moveLeftButton || !this.moveRightButton) {
            console.error('One or more required elements could not be found');
            return;
        }
        
        this.moveRightButton.addEventListener('click', () => this.moveSelected(this.leftSelect, this.rightSelect));
        this.moveLeftButton.addEventListener('click', () => this.moveSelected(this.rightSelect, this.leftSelect));
    }

    updateHiddenInput() {
        let selOptions = Array.from(this.rightSelect.querySelectorAll('option')).map(option => option.value);
        this.hiddenInput.value = selOptions.join(';');

        // Dispatch a 'change' event
        let event = new Event('change');
        this.hiddenInput.dispatchEvent(event);
    }

    sortSelect(selGroup) {
        const sortedArray = Array.from(selGroup.children).sort(function(a, b) {
            return a.text.localeCompare(b.text);
        });
        sortedArray.forEach(option => {
            selGroup.appendChild(option);
        });
    }
}

export default MultiSelectTransfer;
